import { cva, type VariantProps } from 'class-variance-authority'

import { cn } from '@/lib/utils'

const textVariants = cva('', {
  variants: {
    variant: {
      default: 'text-dark-600',
      muted: 'text-dark-600',
      light: 'text-dark-300',
      primary: 'text-dark-900',
      tertiary: 'text-dark-600',
      formLabel: 'text-dark-700',
    },
    size: {
      xs: 'text-xs',
      sm: 'text-sm',
      base: 'text-base',
      lg: 'text-lg',
      xl: 'text-xl',
      '2xl': 'text-2xl',
      '3xl': 'text-3xl',
      '4xl': 'text-4xl',
    },
    weight: {
      normal: 'font-normal',
      medium: 'font-medium',
      semibold: 'font-semibold',
      bold: 'font-bold',
    },
  },
  defaultVariants: {
    variant: 'default',
    size: 'base',
    weight: 'normal',
  },
})

type TextElement =
  | 'span'
  | 'p'
  | 'div'
  | 'label'
  | 'h1'
  | 'h2'
  | 'h3'
  | 'h4'
  | 'h5'
  | 'h6'

interface TextProps
  extends React.HTMLAttributes<HTMLElement>,
    VariantProps<typeof textVariants> {
  as?: TextElement
  htmlFor?: string
}

function Text({
  className,
  variant,
  size,
  weight,
  as = 'span',
  htmlFor,
  ...props
}: TextProps) {
  const Component = as
  return (
    <Component
      className={cn(textVariants({ variant, size, weight, className }))}
      htmlFor={htmlFor}
      {...props}
    />
  )
}

export { Text, textVariants }
export type { TextProps }
